export default __webpack_public_path__ + "static/media/sugar2.cc35ee9d.jpeg";